import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import Barcode from 'screens/components/basic/Barcode';
import { connect } from 'react-redux';
import LOOKUP from 'constants/lookup';
import DecimalInput from 'screens/components/basic/DecimalInput';
import Button from 'screens/components/basic/Button';
import ToggleInput from 'screens/components/basic/ToggleInput';
import { applyMemberPrice } from 'actions/FormActions';
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogInput from 'screens/components/advanced/DialogInput';
import MinusAndPlusInput from 'screens/components/basic/MinusAndPlusInput';
import { formInput } from 'actions/FormActions';

class PriceMatrixMeasurementTable extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            printLabelDialog: false,
            barcode: "",
            quantity: "",
            productName: "",
            store: "",
            price: ''
        };
        this.ws = this.props.ws;
    }

    closePrintLabelDialog = () => {
        this.setState({ printLabelDialog: false });
        this.props.clearPrintQuantity("labelQuantityProductBarcode");
    }

    applyMemberPrice = () => {
        this.props.applyMemberPrice(this.props.memberDiscountPercentage);
    }

    printByService = () => {
        const model = {
            command: "PRINT BARCODE",
            data: JSON.stringify([{
                CompanyName: this.state.store,
                ProductName: this.state.productName,
                Quantity: this.state.quantity,
                Barcode: this.state.barcode,
                NumberOfCopies: this.props.printQuantity,
                Price: this.state.price
            }])
        };

        this.ws.send(JSON.stringify(model));
        this.closePrintLabelDialog()
    }

    printByJs = () => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.setState({ printLabelDialog: true });
        } else {
            const toPrint = ReactDOM.createRoot(document.getElementById('to-print'));
            toPrint.render (<Barcode code={this.state.barcode} format={"CODE128B"} width={2} print={true} />);
        }
    }

    printLabel = (barcode, quantity = 1, price = null) => {
        this.setState(pState => {
            return {
                ...pState,
                barcode: barcode,
                quantity: quantity,
                productName: this.props.productName,
                store: this.props.store.name,
                price: price
            }
        }, this.printByJs);
    }


    mapToTableRows = (measurementSettings, productId = 0) => {
        const disabled = this.props.readonly;
        const hideEmpty = this.props.hideEmpty;


        const rows = (measurementSettings || []).filter(item => !hideEmpty || (hideEmpty === true && item.price != 0)).map((item, index) => {
            return {
                WeightSetting: item.name,
                Price: (<DecimalInput key={`price-input-${item.id}-${index}`}
                    name={`${this.props.name}Price${item.id}`}
                    label={LOOKUP.priceMatrix.settings.price.label}
                    hintText={LOOKUP.priceMatrix.settings.price.hintText}
                    disabled={disabled}
                    min={0}
                    max={1000000}
                    underlineShow={true}
                    />),
                MemberPrice: (this.props.isMedical ? <DecimalInput key={`member-price-input-${item.id}-${index}`}
                    name={`${this.props.name}MemberPrice${item.id}`}
                    label={LOOKUP.priceMatrix.settings.price.label}
                    hintText={LOOKUP.priceMatrix.settings.price.hintText}
                    disabled={disabled}
                    min={0}
                    max={1000000}
                    underlineShow={true}
                     /> : ""),
                Status: (<ToggleInput className="matrix_table_campaign_status" disabled={disabled} key={`campaign-toggle-input-${item.id}-${index}`} name={`${this.props.name}IsCampaign_${item.id}`} />),
                icon: (this.props.notPrintLabel ? "" : <Button
                    type="FlatButtonPrimary"
                    name="printLabelButton"
                    label={"PRINT LABEL"}
                    onTouchTap={() => this.printLabel('Z' + (`00000000000${productId}`).slice(-11), 1, item.price)} />)
            };
        });
        return rows;
    }

    render() {
        const p = this.props;
        const data = this.mapToTableRows(p.measurementSettings, p.productId);
        return (
            <div>
                {
                    !p.isMedical ? null :
                        (<div className="row">
                            <div className="col-lg-12">
                                <Button
                                    type="AddButton"
                                    className="pull-right"
                                    name="button"
                                    label={LOOKUP.priceMatrix.controls.applyMemberPrice}
                                    primary={true}
                                    onTouchTap={() => this.applyMemberPrice()} />
                            </div>
                        </div>)
                }
                <br />
                <GenericTable
                    className="price_setting_table tableHeaderwhiteColorFont"
                    tableBodyClassName="price-matrix-weight-table"
                    multiSelectable={false}
                    enableSelectAll={false}
                    displaySelectAll={false}
                    adjustForCheckbox={false}
                    displayRowCheckbox={false}
                    selectable={false}
                    stripedRows={true}
                    columns={this.props.isMedical ? LOOKUP.priceMatrix.settings.tableColumns : LOOKUP.priceMatrix.settings.tableColumnsRetail}
                    rows={data} />

                <DialogInput
                    title={LOOKUP.product.printLabelDialog.title}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonCancel"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={() => this.closePrintLabelDialog()} />,
                        <Button
                            key={2}
                            name="ConfirmButton"
                            label={LOOKUP.product.printLabelDialog.print.label}
                            primary={true}
                            onTouchTap={this.printByService}
                        />]}
                    modal={true}
                    className="printLabelProduct"
                    open={this.state.printLabelDialog}
                >
                    <div className="row d-flex justify-content-center printLabel">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <MinusAndPlusInput
                                name="labelQuantityProductBarcode"
                                minimum="1"
                                maximum="1000"
                            />
                        </div> {/* .col */}
                    </div> {/* .row */}
                </DialogInput>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        store: state.common.store,
        memberDiscountPercentage: state.common.applicationSettings.memberDiscountPercentage,
        printQuantity: state.form.labelQuantityProductBarcode,
        isMedical: state.common.applicationSettings.isMedical
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        applyMemberPrice: (discount) => dispatch(applyMemberPrice(discount, ownProps.name)),
        clearPrintQuantity: (compName) => dispatch(formInput("", compName))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PriceMatrixMeasurementTable);